import React, { Component } from 'react';
import './TopPanel.css';
import PvSoundMeter from "./PvSoundMeter";
import ProgressBar from 'react-bootstrap/ProgressBar';
import VideoInstruction from './VideoInstruction';
import { withTranslation } from "react-i18next";
import { FaSpinner } from 'react-icons/fa';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';


class TopPanel extends Component {
    handleContinueButtonClick = () => {
        this.props.dataChannel.send('{"CONTINUE_BUTTON_CLICKED":true}');
    }

    render() {
        const { t } = this.props;
        return (
            <div className="TopPanel" style={{ height: "100%" }}>
                <div className="TopPanelInnerWrapper" >
                    <Alert variant="filled" severity="info">
                        {this.props.infoBoxMessage}
                    </Alert>
                    <Button
                        variant="contained"
                        onClick={this.props.handleButtonClick}
                        style={{
                            display: this.props.isButtonDisplayed ? "block" : "none",
                            bottom: 0,
                            position: "absolute",
                            right: 0,
                            margin: "20px",
                            fontSize: "40px",
                        }}
                        size="large"
                        color="warning"
                    >
                        {this.props.buttonText}
                    </Button>

                    {this.props.DISPLAY_SOUND_METER && <PvSoundMeter stream={this.props.stream} />}
                    {this.props.DISPLAY_VIDEO_INSTRUCTION && <VideoInstruction VIDEO_INSTRUCTION_ID={this.props.VIDEO_INSTRUCTION_ID} />}
                </div>
            </div>
        );
    }
}

export default withTranslation()(TopPanel);